
import { shallowEqual } from "react-redux";
import { FontAwesomeIcon } from "../../../../../../CommonComponents/AssetsHelper";
import ImageUpload from '../../../../../../CommonComponents/ImageUploader';
import { useSelector } from "react-redux";


const UploadMedia = ({ uploadImage, mediaType, handlePopUp }) => {
  const { userData } = useSelector(state => state.authenticated, shallowEqual);
  const allowCustomUpload = userData?.UserRule?.photo_booth_upload ?? 0;
  const wallId = localStorage.getItem("wallId");
  const ownerId = userData?.user?.ownerId ?? 0;
  return (
    <div className="img rounded overflow-hidden f-center cursor-pointer more-items">
      <ImageUpload uploadPath={`react-app/media/images/photobooth/${mediaType}/${ownerId}/${wallId}/`} uploadAgents={["Instagram", "GoogleDrive", "Url", "Webcam"]} onImgUpload={(path, file) => uploadImage(`${ownerId}/${wallId}/${file?.fileName}`, mediaType)} handlePopUp={allowCustomUpload ? null : handlePopUp} allowedFile={mediaType == "frames" ? ['image/png', 'image/jpeg', 'image/jpg'] : ['image/*']}>
        <FontAwesomeIcon className="fs-3" type="regular" icon="plus" />
      </ImageUpload>
    </div>
  );
};

export default UploadMedia;